export const cls = <T extends (string | undefined | boolean)[]>(...args: T) => {
  return args.filter((a) => typeof a === 'string').join(' ');
};
